import { Chip, useThemeColors, ColorsV2, Text } from '@electricjs/arc';

import { DynamicFilterKey } from '@/types/storefront';

import { getFilterOptionDisplayName } from '../../utils';

type SelectedOptionChipProps = {
  filterOption: string;
  filterKey: DynamicFilterKey;
  onRemove: (filterOption: string, filterKey: DynamicFilterKey) => void;
};

export const SelectedOptionChip = ({
  filterOption,
  filterKey,
  onRemove,
}: SelectedOptionChipProps) => {
  const primaryColor = useThemeColors(ColorsV2.PRIMARY_LIGHTEST);

  return (
    <Chip
      id={`dynamic-filter-selected-option-chip-${filterKey}-${filterOption}`}
      removeIcon="close"
      onRemove={() => onRemove(filterOption, filterKey)}
      backgroundColor={primaryColor}>
      <Text variant="label-large">
        {getFilterOptionDisplayName(filterKey, filterOption)}
      </Text>
    </Chip>
  );
};
